/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
// material
import { EmptyState, displayModal } from '@insticator/insticator-ui';
import ExpandableSection from "../../../../../material/expandablesection/expandablesection";
import ConfigController from "../../../../../material/expandablesection/controllers/configcontroller/configcontroller";
import SectionCard from "../../../../../material/expandablesection/sectioncard/sectioncard";
// styles
import injectSheet from 'react-jss';
import styles from './payment_styles';
import ExistingPayments from './existingpayments/existingpayments';
import SelectPayment from './selectpayment/selectpayment';
import PaymentInfo from './paymentinfo/paymentinfo';
import {updateAccountDetails} from "../../../../../state/thunks/account";



/* ========== ~~~~~~~~~~ PAYMENT  ~~~~~~~~~~ ========== */
const Payment = injectSheet(styles)((props) => {
  const dispatch = useDispatch()
  const { account: { paymentInfo, cachedCompanyInfo }, session: { accountUUID}} = useSelector((state) => state)
  const {current, updating} = useSelector((state) => state.account.paymentTerm)
  
  const [isOpened, setIsOpened] = useState(false);
  const [isChanged, setIsChanged] = useState(false)
  const [paymentData, setPaymentData] = useState(null)
  const [selectedNewPayment, selectNewPayment] = useState(null) 
  const [navHistory, setNavHistory] = useState(['EXISTINGPAYMENTS']) // history of payment section view

  const hasNoPaymentMethod = paymentInfo?.paymentInfo.length && paymentInfo.paymentInfo.filter(payment => payment.paymentType === 'NONE').length

  useEffect(() => {
    // set initial view of payment info depending if there is an existing payment method
    if(hasNoPaymentMethod) setNavHistory(['NOPAYMENTMETHOD'])
    else setNavHistory(['EXISTINGPAYMENTS'])
  }, [hasNoPaymentMethod])

  useEffect(() => {
      if (updating && current !== updating) setIsChanged(true)
      else setIsChanged(false)
  }, [current, updating])

  const moveForward = view => setNavHistory([...navHistory, view])

  const moveBack = () => setNavHistory([...navHistory].slice(0, -1))

  const currentPage = [...navHistory].pop()

  const handleViewPaymentDetails = payment =>  {
    setPaymentData(payment)
    moveForward(payment.paymentType)
  }

  const goToSelectPaymentMethod = () => moveForward('SELECTPAYMENT')

  const paymentInfoBack = view => {
    dispatch(displayModal(false))
    setPaymentData(null)
    selectNewPayment(null)
    if(view) setNavHistory([view])
    else moveBack()
  }

  const selectNewPaymentBack = () => {
    selectNewPayment(null)
    moveBack()
  }

   const renderCurrentView = () => {
    const savedPaymentTypes = paymentInfo.paymentInfo.map(payment => payment.paymentType)    
    const preferredPayments =  paymentInfo.paymentInfo.filter(payment => payment.preferredPayment === true)
    const preferredPaymentType = preferredPayments.length ? preferredPayments[0].paymentType : null

    switch(currentPage) {
      case 'EXISTINGPAYMENTS':
        return <ExistingPayments 
          paymentInfo={paymentInfo?.paymentInfo || []}  
          viewPaymentDetails={handleViewPaymentDetails} 
          addPaymentMethod={goToSelectPaymentMethod} 
        />
      case 'SELECTPAYMENT':
        return <SelectPayment 
          selectedPayment={selectedNewPayment} 
          savedPaymentTypes={savedPaymentTypes}
          selectPayment={val => selectNewPayment(val)} 
          moveBack={selectNewPaymentBack} 
          moveForward={() => {
            moveForward(selectedNewPayment)
          }}
        />
      default:
        return <PaymentInfo 
          preferredPaymentType={preferredPaymentType} 
          type={currentPage} 
          payment={paymentData} 
          payoutThreshold={paymentInfo.payoutThreshold} 
          moveBack={paymentInfoBack} 
        />
    }     
  }

  const handleToggle = () => setIsOpened(!isOpened)

  const controller = (
    <ConfigController
      handleToggle={handleToggle}
      handleCancel={handleToggle}
      isOpened={isOpened}
      configTitle={'View'}
      cancelTitle={'Close'}
      title='Payment Information'
    />
  );

  return (
    <ExpandableSection
      className={`payment ${props.classes.payment}`}
      controller={controller}
      isOpened={isOpened}
      handleCancel={handleToggle}
      cancelTitle={'Cancel/Close'}
      handleSave={() => {
        const companyInfo = {...cachedCompanyInfo}
        companyInfo.paymentTerm = updating
        dispatch(updateAccountDetails({accountUUID, cachedCompanyInfo: companyInfo}))
      }}
      isChanged={isChanged}
    >
      {isOpened && <>
        <SectionCard>
          { paymentInfo && 
            <>
             { hasNoPaymentMethod && currentPage === 'NOPAYMENTMETHOD' ?
              <EmptyState 
                graphicName={`payment`}
                graphicText={`Check and Credit Cards`}
                bodycopy={`You have no registered payment methods. Add one to receive payments from COOL Media.`}
                buttonName={`addpayment`}
                buttonText={`Add Payment Method`}
                buttonClick={goToSelectPaymentMethod}
              />
              :
              renderCurrentView()
            }
            </>
          }
        </SectionCard>
        </>}
    </ExpandableSection>
  )
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Payment